export const phoneInputStyles = `
  .phone-input {
    width: 100%;
  }
  
  .phone-input .PhoneInputInput {
    width: 100%;
    height: 56px;
    padding: 16.5px 14px;
    border: 1px solid #E0E0E0;
    border-radius: 4px;
    font-size: 16px;
    font-family: inherit;
    background-color: #fff;
    color: #000000;
    transition: border-color 0.2s ease;
  }
  
  .phone-input .PhoneInputInput:focus {
    outline: none;
    border-color: #E0E0E0;
    border-width: 2px;
  }
  
  .phone-input .PhoneInputInput:hover {
    border-color: #E0E0E0;
  }
  
  .phone-input.error .PhoneInputInput {
    border-color: #d32f2f;
  }
  
  .phone-input .PhoneInputCountry {
    margin-right: 8px;
  }
  
  .phone-input .PhoneInputCountrySelect {
    background: transparent;
    border: none;
    font-size: 14px;
    color: #000000;
  }
  
  .phone-input .PhoneInputCountryIcon {
    width: 20px;
    height: 15px;
  }
`;